module.exports = __webpack_public_path__ + "static/media/create-24px.e62249ce.svg";